import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText, TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function ExtraReasonDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [reason, setReason] = useState('');

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {t('Actions taken')}
            </DialogTitle>
            <DialogContent className={classes.noOverflow}>
                <DialogContentText key={'ExtraReasonDialogText'} className={classes.dialogContext}>
                    {t('MultipleWarningCorrections')}
                </DialogContentText>
                <DialogContentText key={'ExtraReasonDialogList'} className={classes.dialogContextList}>
                    <ul>
                        {props.reasonMistakes.map((r, rIndex) => { return <li key={'rIndex_' + rIndex}>{r}</li> })}
                    </ul>

                </DialogContentText>
                <DialogContentText key={'ExtraReasonDialogInput'} className={classes.dialogContext}>
                    <TextField id="outlined-search" variant="outlined" fullWidth multiline maxRows={4} className={classes.qualityCheckTextField} value={reason} onChange={(e) => setReason(e.target.value)} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.okButton} autoFocus onClick={() => props.enterExtraReason(reason)}>
                        {t('SAVE')}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "1200px !important",
        maxWidth: "1200px !important",
        // height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "100%",
        textAlign: "center"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move',
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    dialogContextList: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "left",
        overflow: "hidden"
    },
    noOverflow: {
        overflow: "hidden"
    }
}));
